import { IApiLink } from "@/types";
import { ApiLinkEntity, ApiLinkRel } from 'config/constants';
import { TenantWarehouseLabelData } from 'models/TenantWarehouse';
import CollectiveReferenceNumber, { ICollectiveReferenceNumberDto } from './CollectiveReferenceNumber';
import ProfitCenter from './ProfitCenter';

export enum CollectiveReferenceNumbersRule {
    general = "general",
    homebase = "homebase",
    profitCenter = "profitCenter"
}

export interface IGetCollectiveReferenceNumbersDto {
    rule: CollectiveReferenceNumbersRule
    entities: ICollectiveReferenceNumberDto[]
    links: IApiLink[]
}

export default class CollectiveReferenceNumbers {
    rule: CollectiveReferenceNumbersRule
    items: CollectiveReferenceNumber[]
    linkCreate?: IApiLink
    linkUpdateRule?: IApiLink

    constructor({ rule, entities, links }: IGetCollectiveReferenceNumbersDto) {
        this.rule = rule
        this.items = entities.map(itemDto => new CollectiveReferenceNumber(itemDto))
        this.linkCreate = links?.find(lnk =>
            lnk.entity === ApiLinkEntity.collectiveReferenceNumber
            && lnk.rel === ApiLinkRel.new
        )
        this.linkUpdateRule = links?.find(lnk =>
            lnk.entity === ApiLinkEntity.collectiveRefNumberRule
            && lnk.rel === ApiLinkRel.update
        )
    }

    joinWarehousesName(warehouses: TenantWarehouseLabelData[]) {
        this.items.forEach(item => item.addWarehouseName(warehouses))
    }
    joinProfitCenterName(profitCenters: ProfitCenter[]) {
        this.items.forEach(item => item.addProfitCenterName(profitCenters))
    }

}
